<template>
  <div>
        <h3 class="page__title">报表提醒</h3>
    
    <div class="page__bd">
        <div class="weui-form-preview">
            <div class="weui-form-preview__hd left
            ">
                <div class="weui-form-preview__item">
                    <span class="weui-form-preview__value" style="font-size:20px">SaaS服务费缴费通知</span>
                </div>
            </div>
            <div class="weui-form-preview__bd">
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">时间区间</label>
                    <span class="weui-form-preview__value" >2022年10月</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">本月收入</label>
                    <span class="weui-form-preview__value">￥10000.00</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">待缴费用</label>
                    <span class="weui-form-preview__value">￥300.00</span>
                </div>
            </div>
            
            <div class="weui-form-preview__ft"><!--
                <a class="weui-form-preview__btn weui-form-preview__btn_default" href="javascript:">辅助操作</a> -->
                <a class="weui-form-preview__btn weui-form-preview__btn_primary" href="javascript:">去缴费</a>
            </div>
        </div>

        
        <div class="weui-form-preview">
            <div class="weui-form-preview__hd left">
                <div class="weui-form-preview__item">
                    <span class="weui-form-preview__value" style="font-size:20px">SaaS服务费缴费通知</span>
                </div>
            </div>
            <div class="weui-form-preview__bd">
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">时间区间</label>
                    <span class="weui-form-preview__value" >2022年10月</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">本月收入</label>
                    <span class="weui-form-preview__value">￥10000.00</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">待缴费用</label>
                    <span class="weui-form-preview__value">￥300.00</span>
                </div>
            </div>
            
            <div class="weui-form-preview__ft"><!--
                <a class="weui-form-preview__btn weui-form-preview__btn_default" href="javascript:">辅助操作</a> -->
                <a class="weui-form-preview__btn weui-form-preview__btn_primary" href="javascript:">去缴费</a>
            </div>
        </div>
        
        <div class="weui-form-preview">
            <div class="weui-form-preview__hd left">
                <div class="weui-form-preview__item">
                    <span class="weui-form-preview__value" style="font-size:20px">SaaS服务费缴费通知</span>
                </div>
            </div>
            <div class="weui-form-preview__bd">
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">时间区间</label>
                    <span class="weui-form-preview__value" >2022年10月</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">本月收入</label>
                    <span class="weui-form-preview__value">￥10000.00</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">待缴费用</label>
                    <span class="weui-form-preview__value">￥300.00</span>
                </div>
            </div>
            
            <div class="weui-form-preview__ft"><!--
                <a class="weui-form-preview__btn weui-form-preview__btn_default" href="javascript:">辅助操作</a> -->
                <a class="weui-form-preview__btn weui-form-preview__btn_primary" href="javascript:">去缴费</a>
            </div>
        </div>
    </div>
  </div>
</template>
  
<script>
import ChartLine from '../components/chartLine.vue'
import boxGraph from '../components/boxGraph.vue'

import 'bootstrap/dist/css/bootstrap.css'

export default {

  data () {
    return {
      msg: 'hello',
      name:'张雪',
      xData: ['2020-02', '2020-03', '2020-04', '2020-05'],
      yData: [30, 132, 80, 134],
    }
  },
  mounted() {
    const {name,xData,yData} = this
       console.log(this.$refs)
       // this.$refs.chart_line_one.initChart(name,xData,yData)
       this.$refs.chart_line_box.initChart(name,xData,yData)
  },
    components: {
       ChartLine,
       boxGraph,
    },
  methods: {
    handleClick () {
      this.$weui.dialog({
        title: '提示',
        content: '是否领取礼品',
        buttons: [{
            label: '取消',
            type: 'default',
            onClick: () => {
              console.log('您已取消领取礼品！')
            }
          }, {
            label: '确定',
            type: 'primary',
            onClick: () => {
            console.log('您已确定领取礼品！')
            }
          }
        ]
      })
    }
  }
}
</script>
<style>
.center{align-content: center;align-self: center;text-align: center;}
.left{align-content: center;align-self: center;text-align: left;}
</style>


// WEBPACK FOOTER //
// src/views/apply_maintanance.vue